<template>
  <div style="width: 100px;" v-if="object[field.id]">
    <expandable-image :src="object[field.id]"/>
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object
  }
})

</script>
